import { BlogSectionProps } from "@/components/types"
import { BiQuestionMark } from "react-icons/bi"
import { GiGuards, GiLetterBomb } from "react-icons/gi"

const allArticles = {
  quoiDeNeufSion: [
      {
        type: "pdf",
        title: "Calcémie Corrigée",
        tag: "calcemie-corrigee",
        pdfPath: "/documents/amelioration-du-dosage-de-la-calcemie.pdf",
        image: "https://plus.unsplash.com/premium_photo-1750785494644-8eff3405dca4?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        number: 1,
        date: "2018-06-02",
        pages: 2,
        timeToRead: "6 min",
        resume: "La mesure du calcium ionisé est la méthode gold standard, mais en son absence, le calcium corrigé est le meilleur évaluateur de la calcémie vraie du patient."
      },
      {
        type: "pdf",
        title: "PSA — Antigène Prostatique Spécifique",
        tag: "psa-antigene-prostatique-specifique",
        pdfPath: "/documents/le-psa-depistage-cancer-prostate.pdf",
        image: "https://images.unsplash.com/photo-1715111183886-5048b76cc917?q=80&w=764&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        number: 2,
        date: "2018-08-01",
        pages: 3,
        timeToRead: "6 min",
        resume: "Si la mesure du PSA total est déterminante, l'évaluation du rapport PSA libre/PSA total donne une meilleure orientation diagnostique pour le dépistage du cancer de la prostate."
      },
      {
        type: "pdf",
        title: "Examen Cytobactériologique Des Crachats",
        tag: "cytobacteriologie-des-crachats",
        pdfPath: "/documents/examen-cytobacteriologique-des-crachats.pdf",
        image: '/images/blog/cytobacteriologie-des-crachats.webp',
        number: 3,
        date: "2018-11-06",
        pages: 2,
        timeToRead: "5 min",
        resume: "L’ECBC est un examen clé et non invasif dans la prise en charge des pneumopathies bactériennes"
      },
      {
        type: "pdf",
        title: "Numération Formule Sanguine (NFS)",
        tag: "numeration-formule-sanguine-nfs",
        pdfPath: "/documents/la-numeration-formule-sanguine.pdf",
        image: "https://plus.unsplash.com/premium_photo-1723044801071-1fef0817e1c2?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        number: 4,
        date: "2019-02-01",
        pages: 6,
        timeToRead: "10 min",
        resume: "Une interprétation correcte de l'hémogramme permet d'orienter vers des pistes diagnostiques et vers la prescription rationnelle d'examens complémentaires."
      },
      {
        type: "pdf",
        title: "Biochimie du Sperme",
        tag: "biochimie-du-sperme",
        pdfPath: "/documents/la-biochimie-du-sperme.pdf",
        image: "https://images.unsplash.com/photo-1631824680987-8bae525fc696?q=80&w=1008&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        number: 5,
        date: "2022-04-01",
        pages: 2,
        timeToRead: "5 min",
        resume: "L'analyse biochimique du plasma séminal est un outil extrêmement précieux dans le domaine de l'infertilité masculine. Elle renseigne sur l'aspect fonctionnel de l'épididyme, de la prostate et des vésicules séminales."
      },
      {
        type: "pdf",
        title: "NT-proBNP",
        tag: "nt-probmp",
        pdfPath: "/documents/le-nt-probnp.pdf",
        image: "https://images.unsplash.com/photo-1567974775951-4a1759f26045?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        number: 6,
        date: "2024-07-01",
        pages: 3,
        timeToRead: "7 min",
        resume: "Le NT-proBNP est le marqueur biologique actuel le plus puissant dans le diagnostic et le suivi de l'insuffisance cardiaque. Il permet d'exclure l'insuffisance cardiaque comme cause de dyspnée."
      },
      {
        type: "pdf",
        title: "Procalcitonine",
        tag: "procalcitonine",
        pdfPath: "/documents/la-procalcitonine.pdf",
        image: "https://plus.unsplash.com/premium_photo-1669301638284-ed33553ef8fa?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        number: 7,
        date: "2024-07-01",
        pages: 3,
        timeToRead: "5 min",
        resume: "La procalcitonine est le marqueur le plus performant pour établir l'origine bactérienne d'un syndrome inflammatoire. Sa production est spécifique de l'origine bactérienne, parasitaire ou fongique."
      },
      {
        type: "pdf",
        title: "Liquide d'Épanchement",
        tag: "liquide-d-epanchement",
        pdfPath: "/documents/les-liquides-d-epanchement.pdf",
        image: "https://images.unsplash.com/photo-1742414313563-c1586482b5ee?q=80&w=735&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        number: 8,
        date: "2024-09-01",
        pages: 4,
        timeToRead: "10 min",
        resume: "L'analyse biochimique, microbiologique et cytologique des liquides d'épanchement est indispensable pour avancer dans la démarche diagnostique des diverses pathologies."
      },
      {
        type: "pdf",
        title: "Gastropanel",
        tag: "gastropanel",
        pdfPath: "/documents/gastropanel.pdf",
        image: "https://images.unsplash.com/photo-1715111965648-4832e0890916?q=80&w=761&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        number: 9,
        date: "2025-02-01",
        pages: 3,
        timeToRead: "7 min",
        resume: "Premier test non invasif pour le diagnostic et la classification des gastrites. Le GastroPanel contient des biomarqueurs dont le pepsinogène I, le pepsinogène II, la gastrine-17 et les anticorps anti-Helicobacter pylori."
      },
      {
        type: "pdf",
        title: "Le FIB-4",
        tag: "fib-4",
        pdfPath: "/documents/le-fib-4.pdf",
        image: '/images/blog/fib-4.jpg',
        number: 10,
        date: "2025-02-01",
        pages: 2,
        timeToRead: "5 min",
        resume: "un nouvel outil simple et efficace de dépistage des maladies chroniques du foie."
      },
      {
        type: "pdf",
        title: "Le Cortisol",
        tag: "le-cortisol",
        pdfPath: "/documents/le-dosage-du-cortisol.pdf",
        image: "https://plus.unsplash.com/premium_photo-1722622864970-be2ea1c24f6f?q=80&w=1536&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        number: 11,
        date: "2025-03-01",
        pages: 2,
        timeToRead: "6 min",
        resume: "Le dosage du cortisol est un outil important pour le diagnostic des pathologies surrénaliennes. Il est indiqué dans le diagnostic du dysfonctionnement des glandes surrénales notamment en cas de suspicion d'hyper ou d'hypo-corticisme."
      },
      {
        type: "pdf",
        title: "L’apolipoprotéine B ",
        tag: "apolipoproteine-b",
        pdfPath: "/documents/l-apolipoproteine-b.pdf",
        image: '/images/blog/APOC3.png',
        number: 12,
        date: "2025-10-01",
        pages: 2,
        timeToRead: "4 min",
        resume: "Les maladies cardiovasculaires (MCV) sont un problème majeur de santé publique, caractérisées surtout par leur évolution silencieuse"
      },
      {
        type: "pdf",
        title: "CRP Ultrasensible",
        tag: "crp-ultrasensible",
        pdfPath: "/documents/la-crp-ultra-sensible.pdf",
        image: "https://plus.unsplash.com/premium_photo-1674904827807-6577b4bb80f9?q=80&w=715&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        number: 13,
        date: "2025-11-01",
        pages: 2,
        timeToRead: "5 min",
        resume: "La CRP ultra-sensible est un bio-marqueur efficace dans la prédiction du risque cardiovasculaire. Elle met en évidence les microinflammations responsables du développement et de la progression des maladies cardiovasculaires."
      },
      {
        type: "pdf",
        title: "L’Albumine Modifiée par l’Ischémie (IMA)",
        tag: "albumine-modifiee-par-l-ischemie-ima",
        pdfPath: "/documents/albumine-modifiee-par-l-ischemie-ima.pdf",
        image: "https://images.unsplash.com/photo-1628348070889-cb656235b4eb?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        number: 14,
        date: "2026-05-11",
        pages: 3,
        timeToRead: "8 min",
        resume: "L’IMA est un biomarqueur précoce de l’ischémie, détectable dès 6 à 10 minutes après le début de l’épisode ischémique, là où la troponine ne s’élève qu’après 3 à 6 heures. Un outil rapide et peu coûteux pour le triage des douleurs thoraciques aux urgences."
      }
  ],
}

export const blogSections: BlogSectionProps[] = [
  {
    label: "Quoi de neuf SION ?",
    tag: 'quoi-de-neuf-sion',
    articles : allArticles.quoiDeNeufSion,
    Icon: BiQuestionMark
  },
  {
    label: "Conseils De La Semaine",
    tag: 'weekly-advice',
    Icon: GiGuards
  },
  {
    label: "Actualités Médicales",
    tag: 'news',
    articles: [...allArticles.quoiDeNeufSion].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 6),
    Icon: GiLetterBomb
  }
]